import { render, staticRenderFns } from "./Alliance.vue?vue&type=template&id=72061132&scoped=true"
import script from "./Alliance.vue?vue&type=script&lang=js"
export * from "./Alliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72061132",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72061132')) {
      api.createRecord('72061132', component.options)
    } else {
      api.reload('72061132', component.options)
    }
    module.hot.accept("./Alliance.vue?vue&type=template&id=72061132&scoped=true", function () {
      api.rerender('72061132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/components/Alliance.vue"
export default component.exports